import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-dialog-titlebar p-dialog-titlebar-icon" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_3 = { class: "p-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "dateFrom" }, "Date From", -1)
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "dateTo" }, "Date To", -1)
const _hoisted_7 = { class: "p-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "filterName" }, "Or Filter", -1)
const _hoisted_9 = { class: "p-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "storeID" }, "Store", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.productDialog,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.productDialog) = $event)),
    style: { width: '50vw' },
    maximizable: true,
    position: "top",
    class: "p-fluid",
    modal: true,
    closable: true,
    onHide: _ctx.closeDialog
  }, {
    header: _withCtx(() => [
      _createElementVNode("h5", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.dialogTitle), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        type: "submit",
        label: "Search",
        icon: "pi pi-search",
        class: "p-button-primary",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.searchRecords()), ["prevent"]))
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Calendar, {
          id: "dateFrom",
          modelValue: _ctx.item.date1,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.date1) = $event)),
          selectionMode: "single",
          dateFormat: "dd-mm-yy",
          onClick: _ctx.clearFilterName
        }, null, 8, ["modelValue", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_Calendar, {
          id: "dateTo",
          modelValue: _ctx.item.date2,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.item.date2) = $event)),
          selectionMode: "single",
          dateFormat: "dd-mm-yy",
          onClick: _ctx.clearFilterName
        }, null, 8, ["modelValue", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Dropdown, {
          id: "filterName",
          modelValue: _ctx.item.filterName,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.filterName) = $event)),
          options: _ctx.filterList,
          optionLabel: "key",
          onChange: _ctx.clearDates
        }, null, 8, ["modelValue", "options", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_Dropdown, {
          id: "storeID",
          modelValue: _ctx.item.storeID,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.storeID) = $event)),
          options: _ctx.storeList,
          optionLabel: "name"
        }, null, 8, ["modelValue", "options"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}